import { Injectable } from '@angular/core';

import { WindowRef } from '@frontend/vanilla/core';

@Injectable()
export class PromoClientContentLoader {
    constructor(private windowRef: WindowRef) {}

    SetClientContentObject(promoItemChildContent: any): void {
        // eslint:disable-next-line:no-string-literal
        this.windowRef.nativeWindow['promoContent'] = JSON.parse(promoItemChildContent);
    }
}
